import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { downloadCsv } from "@/lib/api";

export const ExportCsvButton = ({ path, filenamePrefix, label = "Export CSV", testid }) => {
    const [busy, setBusy] = useState(false);

    const onClick = async () => {
        setBusy(true);
        try {
            await downloadCsv(path, filenamePrefix);
            toast.success("Download started");
        } catch {
            toast.error("Export failed. Please try again.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <Button
            variant="outline"
            onClick={onClick}
            disabled={busy}
            className="h-9 px-3 font-medium bg-white border-ph-border text-ph-text hover:bg-ph-canvas hover:text-ph-text transition-colors"
            data-testid={testid}
        >
            {busy ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Download className="w-4 h-4 mr-1.5" />}
            {label}
        </Button>
    );
};

export default ExportCsvButton;
